<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
  <div>
    <!-- <v-menu bottom right transition="slide-y-transition">
      <template v-slot:activator="{ on }">
        <v-btn class="mr-4" dark small color="purple darken-1" v-on="on" @click="openSurvey">
          <v-icon left class="outlined">ballot</v-icon>Survey
        </v-btn>
      </template>

      <v-dialog v-model="surveyCovid" max-width="50%" :fullscreen="$vuetify.breakpoint.mdAndDown" persistent>
        <v-card>
          <v-card-title class="title purple darken-1 white--text">COVID-19 Survey
            <v-btn
          icon
          dark
          @click.native="surveyCovid = false"
          style="position: absolute;right: 10px;top: 10px;"
        >
          <v-icon>close</v-icon>
        </v-btn>
          </v-card-title>
          <v-card-text>
            <div>
              <Survey
                ref="Survey"
                @message_survey="SurveySubmit"
                :surveyGuid="surveyGuid"
                :surveyLastSubmitDate="surveyLastSubmitDate"
                :haveSubmittedSurvey="haveSubmittedSurvey"
              ></Survey>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-menu> -->

    <v-menu bottom right transition="slide-y-transition">
      <template v-slot:activator="{ on }">
        <v-btn class="mr-2" dark small :block="$vuetify.breakpoint.xsOnly" color="purple darken-1" v-on="on" @click="dialogHydra = true; sendGA('info', 'hydrariskmgmnt');"
          v-bind:style="{ 'font-size': $vuetify.breakpoint.smAndDown? '10px !important': '10px' }">
          <v-icon left class="outlined">people</v-icon>GET YOUR WORKPLACE COVID-19 COMPLIANT
        </v-btn>
      </template>
    </v-menu>

    <v-menu bottom right transition="slide-y-transition">
      <template v-slot:activator="{ on }">
        <v-btn class="mr-4" dark small color="purple darken-1" v-on="on">
          <v-icon left>link</v-icon>Share
        </v-btn>
      </template>

      <v-list dark color="#181745" width="220">
        <social-sharing
          url="https://health.hydra.africa/"
          title="COVID-19 Awareness available to all South Africans."
          description="Get all the up-to-date information on COVID-19 for South Africa in one place, with in-depth insights and analysis so you're #SmartandAware."
          quote="Get all the up-to-date information on COVID-19 for South Africa in one place, with in-depth insights and analysis so you're #SmartandAware."
          hashtags="SMARTandAWARE,awareness,hydra,covid-19"
          twitter-user="AwarenessCo"
          inline-template
          @open="sendGA('share')"
        >
          <div>
            <network network="whatsapp">
              <div class="pa-1 ml-3 mb-3" style="cursor: pointer;">WhatsApp</div>
            </network>
            <network network="twitter">
              <div class="pa-1 ml-3 mb-3" style="cursor: pointer;">Twitter</div>
            </network>
            <network network="facebook">
              <div class="pa-1 ml-3 mb-3" style="cursor: pointer;">Facebook</div>
            </network>
            <network network="linkedin">
              <div class="pa-1 ml-3 mb-3" style="cursor: pointer;">LinkedIn</div>
            </network>
          </div>
        </social-sharing>
      </v-list>
    </v-menu>
    <v-menu bottom right transition="slide-x-reverse-transition">
      <template v-slot:activator="{ on }">
        <v-btn dark icon v-on="on">
          <v-icon large>menu</v-icon>
        </v-btn>
      </template>

      <v-list dark color="#181745" width="220">
        <v-list-item @click="dialogCovid = true; sendGA('info', 'covid19');">
          <v-list-item-title>About COVID-19</v-list-item-title>
        </v-list-item>
        <v-list-item @click="dialogSymptoms = true; sendGA('info', 'symptoms');">
          <v-list-item-title>Symptoms</v-list-item-title>
        </v-list-item>
        <v-list-item @click="dialogPrecautions = true; sendGA('info', 'prevention');">
          <v-list-item-title>Prevention</v-list-item-title>
        </v-list-item>
        <v-list-item @click="dialogTesting = true; sendGA('info', 'testing');">
          <v-list-item-title>Testing</v-list-item-title>
        </v-list-item>
        <v-list-item @click="dialogContacts = true; sendGA('info', 'contacts');">
          <v-list-item-title>Useful Contacts</v-list-item-title>
        </v-list-item>
        <v-list-item @click="dialogAbout = true; sendGA('info', 'about');">
          <v-list-item-title>About this App</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-dialog v-model="dialogCovid" max-width="600" :fullscreen="$vuetify.breakpoint.mdAndDown">
      <v-card>
        <v-card-title class="title purple darken-1 white--text">What is COVID-19?</v-card-title>
        <v-card-text>
          <div class="body-1 mt-3">
            Corona viruses are large groups of viruses that are common amongst animals. Those viruses can make people sick, usually with a mild to moderate upper respiratory tract illness, similar to a common cold.
            <br />
            <br />A new Coronavirus called COVID-19 was identified in China and is associated with an outbreak of pneumonia.
          </div>
          <div class="caption mt-5">
            Source:
            <a href="https://wa.me/27600123456" target="_blank">National Department of Health</a>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.native="dialogCovid = false" color="purple">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSymptoms" max-width="600" :fullscreen="$vuetify.breakpoint.mdAndDown">
      <v-card>
        <v-card-title class="title purple darken-1 white--text">What are the symptoms?</v-card-title>
        <v-card-text>
          <div class="body-1 mt-3">
            For an estimated 80% of people infected with COVID-19, the results are mild illness as per the symptoms below requiring self-isolation to stop further spread in the community. For a small number the consequences are more serious.
            <br />
            <br />The symptoms of COVID-19 are:
            <br />▪ a cough
            <br />▪ a fever
            <br />▪ shortness of breath
            <br />
            <br />But these symptoms do not necessarily mean you have the illness. The symptoms are similar to other illnesses that are much more common, such as cold and flu.
          </div>
          <div class="caption mt-5">
            Source:
            <a href="https://wa.me/27600123456" target="_blank">National Department of Health</a>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.native="dialogSymptoms = false" color="purple">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogPrecautions"
      max-width="600"
      :fullscreen="$vuetify.breakpoint.mdAndDown"
    >
      <v-card>
        <v-card-title class="title purple darken-1 white--text">What precautions can I take?</v-card-title>
        <v-card-text>
          <div class="body-1 mt-3">
            The best actions you can take to reduce your chance of getting COVID-19 are:
            <br />
            <br />▪ Wash your hands frequently with soap and water. Need to wash your hands but there is no soap and water? Use an alcohol-based hand sanitizer with at least 60% alcohol.
            <br />▪ Avoid touching your eyes, nose and mouth
            <br />▪ Cover your cough or sneeze with a tissue, and throw it away after use
            <br />▪ Avoid close contact with infected people
            <br />▪ Practice Social Distancing
            <br />▪ Wear a cloth mask in public places
            <br />
            <br />If you are mildly sick, keep yourself hydrated, stay at home, and rest.
          </div>
          <div class="caption mt-5">
            Source:
            <a href="https://wa.me/27600123456" target="_blank">National Department of Health</a>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.native="dialogPrecautions = false" color="purple">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogTesting" max-width="600" :fullscreen="$vuetify.breakpoint.mdAndDown">
      <v-card>
        <v-card-title class="title purple darken-1 white--text">How can I get tested?</v-card-title>
        <v-card-text>
          <div class="body-1 mt-3">
            If you feel you have been exposed to COVID-19, or are showing slight symptoms, please avoid contact with other people in your community and self-isolate.
            <br />
            <br />If you feel you are ill and need non-urgent medical care, call your doctor to ask how to be tested. They will need to follow certain steps to get you the specific care you need.
            <br />
            <br />If you are feeling very ill and need care immediately, call your emergency services.
            <br />
            <br />When seeking care, follow these steps:
            <br />▪ Call your healthcare facility and tell them that you have, or are being evaluated for, COVID-19.
            <br />▪ Put on a face mask before you enter the healthcare facility.
            <br />▪ Ask your healthcare professional to inform the NICD.
          </div>
          <div class="caption mt-5">
            Source:
            <a href="https://wa.me/27600123456" target="_blank">National Department of Health</a>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.native="dialogTesting = false" color="purple">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogContacts" max-width="600" :fullscreen="$vuetify.breakpoint.mdAndDown">
      <v-card>
        <v-card-title
          class="title purple darken-1 white--text"
        >What official contact channels can I use?</v-card-title>
        <v-card-text>
          <div class="body-1 mt-3">
            Contact the National Department of Health on WhatsApp:
            <br />0600-123456 or
            <a
              href="https://api.whatsapp.com/send?phone=27600123456&text=Hi&source=&data="
              target="_blank"
            >click here</a>
            <br />
            <br />Contact the National Department of Health Emergency Hotline:
            <br />0800 029 999
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.native="dialogContacts = false" color="purple">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAbout" max-width="70%" :fullscreen="$vuetify.breakpoint.mdAndDown">
      <v-card>
        <v-card-title
          class="title purple darken-1 white--text"
        >About the COVID-19 Public Awareness Dashboard</v-card-title>
        <v-card-text>

          <div style="margin-top:20px;">
            <div class="mb-2">
              <span class="caption grey--text mr-1" style="font-weight: 300;">POWERED BY</span>
              <img src="../../public/assets/hydra.png" style="height: 20px; vertical-align: middle; cursor: pointer;" onclick="window.open('../../assets/COVID-19RiskManagementAwareness.pdf','_blank');">
            </div>
            <div>
              <span class="caption grey--text mr-1" style="font-weight: 300;">DATA SOURCES:</span>
              <a class="caption" href="https://www.gov.za/media-statements" target="_blank">gov.za</a>
              <span class="mr-2">&nbsp;</span>
              <a class="caption" href="https://www.nicd.ac.za/diseases-a-z-index/covid-19/" target="_blank">nicd.ac.za</a>
              <span class="mr-2">&nbsp;</span>
              <a class="caption" href="../../data/toupdate/sources.csv" target="_blank">other</a>
            </div>
            <!-- <div class="mb-2">
              <span class="caption grey--text mr-1" style="font-weight: 300;">LAST UPDATED:</span>
              <span class="caption grey--text">{{lastupdated}}</span>
            </div> -->
            <div>
              <span class="caption grey--text mr-1" style="font-weight: 300;">LEGAL:</span>
              <a class="caption" href="./privacy.html" target="_blank">Privacy Policy</a>
              <span class="mr-2">&nbsp;</span>
              <a class="caption" href="#" @click="dialogDisclaimer = true">Disclaimer</a>
            </div>
            <div>
              <span class="caption grey--text mr-1" style="font-weight: 300;">© 2021 <a href="https://awarenesscompany.co.za" target="_blank">The Awareness Company</a>
              <span class="caption grey--text">. All Rights Reserved.</span></span>
            </div>
          </div>

          <v-dialog v-model="dialogDisclaimer" max-width="70%" :fullscreen="$vuetify.breakpoint.mdAndDown">
            <v-card>
              <v-card-title class="title purple darken-1 white--text">Disclaimer</v-card-title>
              <v-card-text>
                <div class="title mt-3">21 March 2020</div>
                <div class="body-1 mt-3">
                  The information contained on the www.health.hydra.africa website (the "Service") is for general information purposes only. The Awareness Company assumes no responsibility for errors or omissions in the contents on the Service.
                  <br/><br/>
                  In no event shall The Awareness Company be liable for any special, direct, indirect, consequential, or incidental damages or any damages whatsoever, whether in an action of contract, negligence or other tort, arising out of or in connection with the use of the Service or the contents of the Service. The Awareness Company reserves the right to make additions, deletions, or modification to the contents on the Service at any time without prior notice. 
                  <br/><br/>
                  The www.health.hydra.africa website may contain links to external websites that are not provided or maintained by or in any way affiliated with The Awareness Company. Please note that The Awareness Company does not guarantee the accuracy, relevance, timeliness, or completeness of any information on these external websites.
                  <br/><br/>
                  The www.health.hydra.africa website is not in any way affiliated with any official government or health organisations.
                </div>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click.native="dialogDisclaimer = false" color="purple">Close</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <div class="body-1 mt-5">
            The last few months have shown us how important it is to be #SMARTandAWARE – not just for the advancement and evolution of humans, but for our survival as well. Data is what makes us smart. Getting insights and telling stories from that data is what makes us aware. It’s crucial now that we get the right data so we tell the right stories at the right time. This will help us make decisions based on insights and take quick action to protect ourselves, stop the spread and flatten the curve.
            <br />
            <br />As The Awareness Company we have planned interventions that we believe will add value in the fight against COVID-19:
            <br />
            <br />▪ Firstly we are launching a COVID-19 Public Awareness Dashboard that is available for the South African public to use.
            We are using our data, visualisation and decision support skills to transform publicly-available information into insights for public consumption.
            We will as best as possible keep this up to date and will require support as we get scale and usage from the public and as requirements and feedback on value received come in.
            <br />
            <br />▪ We will also use our already-operational technology called HYDRA to help organisations be more agile and make proactive data-driven decisions going forward.
            HYDRA aggregates data from multiple inputs and create a single and complete view of operations to monitor security threats and provide early warning.
            <br />
            <br />
            <a href="../../assets/COVID-19RiskManagementAwareness.pdf" target="_blank">Read more about the platform here</a>
            <br />
            <br />▪ We are also looking to partner with like-minded organisations who will assist us to bring the same advanced insights and awareness to other countries in the rest of Africa.
            <br />
             <br />
            <br />Embed a widget with the latest South Africa counts into your website:
            <br />
            <br /><code style="width: 100%;">&lt;iframe width="50%" height="260px" src="https://health.hydra.africa/widget.html" frameborder="0"&gt;&lt;/iframe&gt;</code>
            <br />
            <br />
            <br />Embed a widget with the latest Africa counts into your website:
            <br />
            <br /><code style="width: 100%;">&lt;iframe width="50%" height="260px" src="https://health.hydra.africa/widget_africa.html" frameborder="0"&gt;&lt;/iframe&gt;</code>
            <br />
            <br />
            <br />Want to get in touch?
            <br />
            <a href="https://awarenesscompany.co.za/#contact" target="_blank">Contact Us</a>
            <br />
            <br />- The Awareness Company
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.native="dialogAbout = false" color="purple">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogHydra" max-width="70%" :fullscreen="$vuetify.breakpoint.mdAndDown">
      <v-card>
        <v-card-title
          class="title purple darken-1 white--text"
        >HYDRA COVID-19 Risk Management Platform</v-card-title>
        <v-card-text>
          <div class="body-1 mt-3">
            The HYDRA COVID-19 Risk Management Platform is an integrated digital platform to enhance decision making and manage the risk for your organisation.
            <br />
            <br />
            <img src="../../public/assets/slide1.png" style="height: 200px;max-width: 100%;" class="mr-3">
            <img src="../../public/assets/symptom.png" style="height: 200px;max-width: 100%;" class="mr-3">
            <img src="../../public/assets/slide5.png" style="height: 200px;max-width: 100%;">
            
            <br />
            <br />DIGITISED SYMPTOM TRACKING
            <br />▪ AI powered insights from periodic symptom tracking.
            <br />▪ Real time risk level awareness from screenings of employees and visitors.

            <br />
            <br />WORKPLACE AND WORKFORCE INSIGHTS
            <br />▪ Enhance Safety and Compliance for your organisation.
           
            <br />
            <br />COVID-19 DATA AND HOTSPOT AREAS
            <br />▪ Up to date regional and provincial hotspots and location intelligence overlays.

            <br />
            <br />OUTCOMES
            <br />▪ Early warning on personnel health and operations risk.
            <br />▪ Prevent loss of income and keep your business operational.
            <br />▪ Building (Indoor) and In-field (Outdoor) location intelligence.
            <br />▪ Safety and security of  people and holistic situational awareness

            <br />
            <br />
            <a href="../../assets/COVID-19RiskManagementAwareness.pdf" target="_blank">Read more about the platform here</a>
              
            <br />
            <br />Want to get in touch?
            <br />
            <a href="mailto:info@awarenesscompany.co.za">Contact Us</a>
            <br />
            <br />- The Awareness Company
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.native="dialogHydra = false" color="purple">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Survey from "../components/Survey";

export default {
  name: "Menu",
  components: {
    Survey
  },
  data: () => ({
    dialogCovid: false,
    dialogSymptoms: false,
    dialogPrecautions: false,
    dialogTesting: false,
    dialogContacts: false,
    dialogAbout: false,
    dialogHydra: false,
    surveyCovid: false,
    surveyGuid: "",
    surveyLastSubmitDate: "",
    haveSubmittedSurvey: null,
    dialogDisclaimer: false
  }),
  methods: {
    sendGA(event, action) {
      //post the GA
      gtag("event", event, {
        event_category: action,
        'send_to': 'UA-161523063-1'
      });
    },
    SurveySubmit(value) {
      //console.log("received some value", value.guid); // someValue
      //this.surveyCovid = false;

      //set date when form was last submit
      var date = new Date();
      var formatDate = this.$moment(date, "DD/MM/YYYY").format(
        "MMMM Do YYYY, h:mm"
      );
      value.date = formatDate;

      this.$cookies.set("survey", value);
      //console.log("the cookie", this.$cookies.get("survey").guid);
      this.haveSubmittedSurvey = this.$cookies.get("survey");
    },
    openSurvey() {
      this.surveyCovid = true;

      this.haveSubmittedSurvey = this.$cookies.get("survey");

      if (this.haveSubmittedSurvey == null) {
        //console.log("Have not submitted a survey yet");
      } else {
        //console.log("Have submitted a survey", this.haveSubmittedSurvey);
        this.surveyGuid = this.haveSubmittedSurvey.guid;
        this.surveyLastSubmitDate = this.haveSubmittedSurvey.date;
        // console.log(
        //   "surveyGuid:",
        //   this.surveyGuid,
        //   "date:",
        //   this.surveyLastSubmitDate
        // );
      }

      //post the GA
      gtag('event', 'survey', {
        'event_category' : 'open',
        'send_to': 'UA-161523063-1'
      });
    }
  }
};
</script>
